// extracted by mini-css-extract-plugin
export default {"guestList":"guestList-module__guestList___ihLW0"};